import React, { useState } from 'react';
import { Empty, ErrorText, Panel, useChrome } from './ceoChrome';

const FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'error', label: 'Errors' },
  { id: 'bug', label: 'Bugs' },
  { id: 'request', label: 'Requests' },
];

export default function SupportInboxPanel({ colors, narrow, data, error, onAction, busy }) {
  const chrome = useChrome(colors, narrow);
  const [filter, setFilter] = useState('all');
  const [notes, setNotes] = useState({});
  const [pendingId, setPendingId] = useState('');
  const [localError, setLocalError] = useState('');
  const items = ((data && data.items) || []).filter((item) => filter === 'all' || item.kind === filter);

  async function save(item) {
    if (!onAction) return;
    setLocalError('');
    try {
      await onAction({
        action: 'update',
        confirm: true,
        source: item.source,
        sourceId: item.sourceId,
        status: notes[`${item.id}:status`] || item.status,
        assigneeNote: notes[item.id] != null ? notes[item.id] : item.assigneeNote,
      });
      setPendingId('');
    } catch (err) {
      setLocalError(err.message || 'Could not update the item');
    }
  }

  return (
    <div style={chrome.page} data-testid="ceo-inbox">
      <div>
        <h2 style={chrome.title}>Support inbox</h2>
        <p style={chrome.sub}>Client errors, bug reports, and support requests. Status is open, in progress, or done.</p>
      </div>
      {error || localError ? <ErrorText>{error || localError}</ErrorText> : null}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {FILTERS.map((item) => (
          <button key={item.id} type="button" onClick={() => setFilter(item.id)} style={{ ...chrome.quiet, background: filter === item.id ? '#1d1d1f' : chrome.surface, color: filter === item.id ? '#fff' : chrome.text }}>
            {item.label}
          </button>
        ))}
      </div>
      {!data && !error ? <Empty chrome={chrome}>Loading…</Empty> : null}
      {data && items.length === 0 ? <Empty chrome={chrome}>Nothing in this list.</Empty> : null}
      {items.map((item) => (
        <Panel key={item.id} chrome={chrome} title={item.title}>
          <div style={{ fontSize: 13, color: chrome.secondary, textTransform: 'capitalize' }}>{item.kind}</div>
          <div style={{ fontWeight: 600, marginTop: 4 }}>{item.title}</div>
          {item.detail ? <p style={chrome.sub}>{item.detail}</p> : null}
          <select
            aria-label={`Status for ${item.title}`}
            value={notes[`${item.id}:status`] || item.status}
            onChange={(event) => setNotes((current) => ({ ...current, [`${item.id}:status`]: event.target.value }))}
            style={{ ...chrome.field, marginTop: 8 }}
          >
            <option value="open">Open</option>
            <option value="in_progress">In progress</option>
            <option value="done">Done</option>
          </select>
          <textarea
            aria-label={`Note for ${item.title}`}
            value={notes[item.id] != null ? notes[item.id] : (item.assigneeNote || '')}
            onChange={(event) => setNotes((current) => ({ ...current, [item.id]: event.target.value }))}
            placeholder="Assignee note"
            style={{ ...chrome.area, marginTop: 8 }}
          />
          {pendingId === item.id ? (
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button type="button" style={chrome.button} disabled={busy} onClick={() => save(item)}>Confirm</button>
              <button type="button" style={chrome.quiet} onClick={() => setPendingId('')}>Cancel</button>
            </div>
          ) : (
            <button type="button" style={{ ...chrome.quiet, marginTop: 8 }} onClick={() => setPendingId(item.id)}>Save</button>
          )}
        </Panel>
      ))}
    </div>
  );
}
